import React from 'react'
import { TextField, Typography } from '@material-ui/core'
import useStyles from './styles'
import BookingTypeVisibility from './booking-type-visibility'
import BookingTypeAccessCode from './booking-type-access-code'

const BookingTypeAdditionalOptions = ({
  errors,
  register,
  setValue,
  status,
  setStatus,
  bookingType,
}) => {
  const classes = useStyles()

  return (
    <>
      <Typography variant="h6">Additional Options</Typography>
      <BookingTypeVisibility
        bookingType={bookingType}
        status={status}
        setStatus={setStatus}
      />
      {status === 'ACTIVE' && (
        <BookingTypeAccessCode
          bookingType={bookingType}
          status={status}
          setStatus={setStatus}
          classes={classes}
          register={register}
          errors={errors}
          setValue={setValue}
        />
      )}
      <Typography variant="subtitle1" gutterBottom>
        Confirmation Message
      </Typography>
      <Typography variant="body2" gutterBottom>
        This message will appear on the confirmation email to your student. Use
        this space to communicate the next steps to your student (where to meet,
        video url, anything else that is important to the session).
      </Typography>
      <TextField
        className={classes.formField}
        multiline
        rows={4}
        name="confirmationMessage"
        label="Create confirmation"
        inputRef={register}
        error={!!errors.confirmationMessage}
        helperText={
          errors.confirmationMessage && errors.confirmationMessage.message
        }
      />
    </>
  )
}

export default BookingTypeAdditionalOptions
